/*
import { userService } from '@/pages/Users/service';
import { router } from '@/router';
import vm from '../main';
const user = JSON.parse(sessionStorage.getItem('user'));
const state = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: null };

const actions = {
  login({ dispatch, commit }, { email, password }) {
    commit('loginRequest', { email });

    userService.logIn(email, password).then(
      user => {
        vm.$snotify.success('Login successful', 'Login');
        commit('loginSuccess', JSON.parse(user.data.token));
        router.push('/');
      },
      error => {
        vm.$snotify.warning('Wrong user or password', 'Login');
        commit('loginFailure', error);
        dispatch('alert/error', error, { root: true });
      }
    );
  },
  logout({ commit }) {
    userService.logOut();
    commit('logout');
  }
};

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  }
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations
};
*/
import { userService } from '@/pages/Users/service';
import { router } from '@/router';
import vm from '../main';
import sharedService from '../shared/service/sharedService';

const emptyObject = {};

const user = JSON.parse(sessionStorage.getItem('user'));
const userState = user
  ? { status: { loggedIn: true }, user }
  : { status: {}, user: {} };

const state = {
  ...userState,
  phoneTypes: [],
}

const getters = {
  loggedIn: state => state.status.loggedIn,
  settings: state => state.user.settings || emptyObject,
  gridsSettings: (state, getters) => getters.settings.grids || emptyObject,
  gridSettingsById: (state, getters) => id => getters.gridsSettings[id] || emptyObject,
  userId: state => state.user.id,
  user: state => state.user,
  isAdministrator: state => state.user.roles.includes('Administrator'),
};

const actions = {
  async login({ dispatch, commit }, { email, password }) {
    commit('loginRequest', { email });

    try {
      const user = await userService.logIn(email, password);
      vm.$snotify.success('Login successful', 'Login');
      commit('loginSuccess', JSON.parse(user.data.token));
      router.push('/');
    } catch (error) {
      vm.$snotify.warning('Wrong user or password', 'Login');
      commit('loginFailure', error);
      dispatch('alert/error', error, { root: true });
    }
  },
  logout({ commit }) {
    userService.logOut();
    commit('logout');
  },
  async saveGridSettings({ state, commit }, { id, settings }) {
    const userSettings = state.user.settings || {};
    const gridSettings = userSettings.grids || {};
    const currentGridSettings = gridSettings[id] || {};

    const settingsObject = {
      ...userSettings,
      grids: {
        ...gridSettings,
        [id]: {
          ...currentGridSettings,
          ...settings,
        },
      },
    };

    await userService.saveSettings({
      id: state.user.id,
      settings: settingsObject,
    });

    commit('saveSettings', settingsObject);
  },
  async getUserSettings({ state, commit }) {
    const settings = await userService.loadSettings(state.user.id);
    commit('saveSettings', settings);
  },
  async getLookupPhoneTypesData({ commit }) {
    const lookupPhoneTypesData = await sharedService.getLookupPhoneTypes();
    commit('setLookupPhoneTypes', lookupPhoneTypesData);
  },
};

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = {
      ...user,
      settings: user.settings ? JSON.parse(user.settings) : {},
    };
  },
  loginFailure(state) {
    state.status = {};
    state.user = {};
  },
  logout(state) {
    state.status = {};
    state.user = {};
  },
  saveSettings(state, payload) {
    state.user.settings = payload;
  },
  setLookupPhoneTypes(state, payload) {
    state.phoneTypes = payload ? payload : [];
  },

};

export const account = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
